import * as marietta from '../..';

class AltitudeLineInfoCollection {
    pX: number;

    pY: number;

    LC: number;

    length: number;

    topDot: marietta.core.Point;

    angle: number;
}
export default AltitudeLineInfoCollection;
